import React from 'react';

import Avatar from '../../assets/img/testimonial/avatar-1.png';

const SingleTestimonial = (props) => {
  const { itemClass, description, authorAvatar, authorName, designation } =
    props;
  return (
    <div className={itemClass ? itemClass : 'it-testimonial-item'}>
      <div className="it-testimonial-ratting">
        <i className="fa-solid fa-star"></i>
        <i className="fa-solid fa-star"></i>
        <i className="fa-solid fa-star"></i>
        <i className="fa-solid fa-star"></i>
        <i className="fa-solid fa-star"></i>
      </div>
      <div className="it-testimonial-text mb-25">
        <p>
          {description
            ? description
            : `“Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris”`}
        </p>
      </div>
      <div className="it-testimonial-author-box d-flex align-items-center">
        <div className="it-testimonial-author mr-15">
          <img src={authorAvatar ? authorAvatar : Avatar} alt="" />
        </div>
        <div className="it-testimonial-author-info">
          <h5>{authorName ? authorName : 'Fiona Perkins'}</h5>
          <span>{designation ? designation : 'Project Manager'}</span>
        </div>
      </div>
    </div>
  );
};

export default SingleTestimonial;
